export default "/images/play-circle.svg?dcf880c0306a61d5aa81ec2960fa6e90";